import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  constructor(private http: HttpClient) {
  }

  createVisit(placeId: string) {
    const body = {placeId};
    return this.http.post(`${API}/api/visits`, body);
  }

  createManualVisit(membershipId: string, placeId: string, begin: string, end: string) {
    const body = {membershipId, placeId, begin, end};
    return this.http.post(`${API}/api/visits/manual`, body);
  }

  getById(visitId: string) {
    return this.http.get(`${API}/api/visits/${visitId}`);
  }

  findVisits(limit: number, skip: number) {
    const params = {limit, skip};
    return this.http.get(`${API}/api/visits`, {params});
  }

  findByUser() {
    return this.http.get(`${API}/api/visits/user`);
  }

  findByUserId(userId: string) {
    return this.http.get(`${API}/api/visits/user/${userId}`);
  }

  findByPlaceId(placeId: string) {
    return this.http.get(`${API}/api/visits/place/${placeId}`);
  }

  findActiveByUser() {
    return this.http.get(`${API}/api/visits/user/active`);
  }

  findActiveByPlaceId(placeId: string) {
    return this.http.get(`${API}/api/visits/place/${placeId}/active`);
  }

  findCompletedByPlaceId(placeId: string) {
    return this.http.get(`${API}/api/visits/place/${placeId}/completed`);
  }

  findCommunityByPlaceId(placeId: string) {
    return this.http.get(`${API}/api/visits/place/${placeId}/community`);
  }

  updateVisit(visitId: string, placeId: string, begin: string, end: string) {
    const body = {placeId, begin, end};
    return this.http.put(`${API}/api/visits/${visitId}`, body);
  }

  end(visitId: string) {
    return this.http.put(`${API}/api/visits/${visitId}/end`, {});
  }

  deactivate(visitId: string) {
    return this.http.put(`${API}/api/visits/${visitId}/deactivate`, {});
  }

}
